<template>
  <div>
    <!-- Start Header Area -->
    <Header>
      <img slot="logo" :src="logo" />
    </Header>
    <!-- End Header Area -->

    <!-- Start Breadcrump Area  -->
    <div
      class="rn-page-title-area pt--40 pb--80 bg_image bg_image--4"
      data-black-overlay="5"
    >
      <v-container>
        <v-row>
          <v-col cols="12">
            <div class="text-center rn-page-title pt--100">
              <h2 class="heading-title" style="color: white;">
                {{ project ? project.title : 'Carregando...' }}
              </h2>
              <p>
                {{ project ? project.description : '' }}
              </p>
            </div>
          </v-col>
        </v-row>
      </v-container>
    </div>
    <!-- End Breadcrump Area  -->

    <!-- Start Portfolio Details Area  -->
    <div class="rn-portfolio-details ptb--120 bg_color--1">
      <v-container>
        <v-row>
          <v-col>
            <div class="portfolio-details">
              <div class="row row--35 mb--50" v-if="project">
                <div class="col-lg-6">
                  <div class="inner">
                    <div class="section-title">
                      <h2 class="heading-title">{{ project.title }}</h2>
                      <p class="description mt--30">
                        {{ project.longDescription }}
                      </p>
                    </div>
                    <div class="flex-wrap portfolio-view-list d-flex">
                      <div class="port-view">
                        <span>Cliente</span>
                        <h4>{{ project.client }}</h4>
                      </div>
                      <div class="port-view">
                        <span>Duração</span>
                        <h4>{{ project.duration }}</h4>
                      </div>
                      <div class="port-view">
                        <span>Categoria</span>
                        <h4>{{ project.category }}</h4>
                      </div>
                    </div>
                    <div class="portfolio-details-btn mt--20">
                      <a
                        class="btn-default btn-border"
                        :href="project.link"
                        target="_blank"
                        >Visitar o Site</a
                      >
                    </div>
                    
                    <!-- Miniaturas da galeria -->
                    <div class="portfolio-gallery-thumbs mt--30">
                      <h5 class="mb--20">Imagens do Projeto</h5>
                                                                             <!-- Imagem principal do projeto -->
                       <div class="portfolio-main-image" v-if="project">
                                                <div class="main-thumb" @click="openImageModal(project.image, project.title)">
                         <img
                           style="width: 100%;border-radius: 8px;cursor: pointer;"
                           :src="project.image"
                           :alt="`Dashboard do sistema ${project.title} - ${project.category} para ${marketNiche} desenvolvido pela Codetime em Itajaí`"
                           width="1200"
                           loading="lazy"
                           decoding="async"
                         />
                       </div>
                       </div>
                      <div class="thumbs-grid">
                        <div 
                          class="thumb-item" 
                          v-for="(image, index) in project.gallery" 
                          :key="index"
                          @click="openImageModal(image, project.title)"
                        >
                          <img
                            :src="image"
                            :alt="`Interface do ${project.title} - Funcionalidade ${index + 1} do sistema de ${marketNiche} desenvolvido pela Codetime`"
                            class="thumb-image"
                            width="320"
                            height="180"
                            loading="lazy"
                            decoding="async"
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col-lg-6">
                  <div
                    class="portfolio-details-accordion mt_lg--40 mt_md--40 mt_sm--40"
                  >
                    <div class="portfolio-details-accordion">
                      <div class="inner">
                        <div class="section-title">
                          <h4 class="heading-title">Funcionalidades Principais</h4>
                          <p class="description mt--30">
                            Principais recursos e funcionalidades implementados neste projeto.
                          </p>
                          <ul class="list-style--1">
                            <li v-for="feature in project.features" :key="feature">
                              <i class="mdi mdi-check-circle-outline"></i>
                              {{ feature }}
                            </li>
                          </ul>
                        </div>
                      </div>
                    </div>
                    <div class="inner mt--40">
                      <div class="section-title">
                        <h4 class="heading-title">Tecnologias Aplicadas</h4>
                        <p class="description mt--30">
                          {{ project.techDescription }}
                        </p>
                        <div class="tech-tags mt--20">
                          <span 
                            v-for="tech in project.tags" 
                            :key="tech"
                            class="tech-tag"
                          >
                            {{ tech }}
                          </span>
                        </div>
                      </div>
                    </div>
                    
                    <!-- Resultados & Impacto -->
                    <div class="inner mt--40" v-if="project.results && project.results.length > 0">
                      <div class="section-title">
                        <h4 class="heading-title">Resultados & Impacto</h4>
                        <p class="description mt--30">
                          Efeitos práticos observados/estimados após a implantação.
                        </p>
                        <ul class="list-style--1">
                          <li v-for="(result, index) in project.results" :key="`result-${index}`">
                            <i class="mdi mdi-check-circle-outline"></i>
                            {{ result }}
                          </li>
                        </ul>
                      </div>
                    </div>
                    
                    <!-- Segurança & Conformidade -->
                    <div class="inner mt--40" v-if="project.compliance && project.compliance.length > 0">
                      <div class="section-title">
                        <h4 class="heading-title">Segurança & Conformidade</h4>
                        <p class="description mt--30">
                          Práticas de segurança, LGPD e validações aplicáveis ao projeto.
                        </p>
                        <ul class="list-style--1">
                          <li v-for="(compliance, index) in project.compliance" :key="`compliance-${index}`">
                            <i class="mdi mdi-check-circle-outline"></i>
                            {{ compliance }}
                          </li>
                        </ul>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </v-col>
        </v-row>
      </v-container>
    </div>
    <!-- End Portfolio Details Area  -->

    <!-- Start Related Work  -->
    <div class="portfolio-related-work pb--120 bg_color--1" v-if="project">
      <v-container>
        <v-row>
          <v-col>
            <div class="text-center section-title">
              <span class="theme-color font--18 fontWeight600"
                >Projetos Relacionados</span
              >
              <h2>Outros Projetos</h2>
            </div>
          </v-col>
        </v-row>
        <v-row class="mt--10">
          <!-- Start Single Work  -->
          <v-col
            lg="3"
            md="6"
            sm="6"
            cols="12"
            v-for="(relatedProject, i) in relatedProjects"
            :key="i"
          >
            <div class="text-center related-work mt--30">
              <div class="thumb">
                <router-link :to="`/portfolio-details/${relatedProject.id}`">
                  <img 
                    :src="relatedProject.image" 
                    :alt="`${relatedProject.title} - ${relatedProject.category} desenvolvido pela Codetime em Itajaí`"
                    width="400"
                    height="200"
                    loading="lazy"
                    decoding="async"
                  />
                </router-link>
              </div>
              <div class="inner">
                <h4>
                  <router-link :to="`/portfolio-details/${relatedProject.id}`">{{ relatedProject.title }}</router-link>
                </h4>
                <span class="category">{{ relatedProject.category }}</span>
              </div>
            </div>
          </v-col>
          <!-- End Single Work  -->
        </v-row>
      </v-container>
    </div>
    <!-- End Related Work  -->

    <!-- Modal de Imagem -->
    <v-dialog v-model="imageModal.show" max-width="90vw" max-height="90vh">
      <v-card class="image-modal">
        <v-card-actions class="pa-0">
          <v-spacer></v-spacer>
          <v-btn icon @click="closeImageModal">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-actions>
        <v-card-text class="pa-0 text-center">
          <img 
            :src="imageModal.image" 
            :alt="imageModal.title"
            class="modal-image"
          />
        </v-card-text>
      </v-card>
    </v-dialog>

    <Footer />
  </div>
</template>

<script>
  import Header from "../../components/header/Header";
  import Footer from "../../components/footer/Footer";
  import { getProjectById, getAllProjects } from "../../data/portfolioProjects";

  export default {
    components: {
      Header,
      Footer,
    },
    data() {
      return {
        logo: "/logoCodetimeWhite.webp",
        project: null,
        relatedProjects: [],
        imageModal: {
          show: false,
          image: '',
          title: ''
        }
      };
    },
    computed: {
      projectId() {
        return this.$route.params.id;
      },
      // Gerar nicho de mercado baseado no projeto
      marketNiche() {
        if (!this.project) return '';
        
        const nicheMap = {
          'healthby': 'Saúde e Clínicas Médicas',
          'jobclin': 'Gestão para Clínicas',
          'gestortop': 'Gestão Administrativa e E-commerce',
          'g6cred': 'Crédito e Financeiro',
          'portal-dos-cegonheiros': 'Logística e Transporte',
          'llp-consultoria': 'Odontologia e Prestação de Serviços',
          'avelar-saude': 'Saúde e Seguros',
          'lebasi': 'Gestão de ILPI (Instituições de Longa Permanência para Idosos)',
          'bitestreet': 'Marketplace de Comida de Rua'
        };
        
        return nicheMap[this.project.id] || this.project.category;
      },
      // Título SEO otimizado
      seoTitle() {
        if (!this.project) return 'Codetime';
        return `${this.project.title}: Sistema de ${this.marketNiche} em Itajaí | Case Codetime`;
      },
      // Descrição SEO otimizada
      seoDescription() {
        if (!this.project) return '';
        const processo = this.project.category === 'Sistema Sob Medida' ? 'processos e gestão' : 'operações';
        return `Veja como desenvolvemos o software da ${this.project.client} que otimizou ${processo}. Soluções de tecnologia para ${this.marketNiche} em Itajaí e região.`;
      }
    },
    watch: {
      projectId: {
        immediate: true,
        handler(newId) {
          this.loadProject(newId);
        }
      }
    },
    beforeDestroy() {
      // Limpar structured data ao sair da página
      document.querySelectorAll('script[data-seo="portfolio"]').forEach(script => script.remove());
    },
    methods: {
      loadProject(id) {
        this.project = getProjectById(id);
        if (this.project) {
          // Carregar projetos relacionados (excluindo o atual)
          this.relatedProjects = getAllProjects().filter(p => p.id !== id).slice(0, 4);
          
          // Configurar SEO
          this.updateMetaTags();
        } else {
          // Projeto não encontrado, redirecionar para 404
          this.$router.push('/404');
        }
      },
      
      updateMetaTags() {
        // Atualizar título da página
        document.title = this.seoTitle;
        
        // Meta description
        let metaDescription = document.querySelector('meta[name="description"]');
        if (!metaDescription) {
          metaDescription = document.createElement('meta');
          metaDescription.setAttribute('name', 'description');
          document.head.appendChild(metaDescription);
        }
        metaDescription.setAttribute('content', this.seoDescription);
        
        // Meta keywords
        const keywords = [
          `desenvolvimento de software ${this.marketNiche}`,
          `sistema para ${this.marketNiche}`,
          'desenvolvimento de software Itajaí',
          `automação para ${this.marketNiche}`,
          `software ${this.project.client}`,
          ...this.project.tags
        ].join(', ');
        
        let metaKeywords = document.querySelector('meta[name="keywords"]');
        if (!metaKeywords) {
          metaKeywords = document.createElement('meta');
          metaKeywords.setAttribute('name', 'keywords');
          document.head.appendChild(metaKeywords);
        }
        metaKeywords.setAttribute('content', keywords);
        
        // Canonical URL
        let canonicalLink = document.querySelector('link[rel="canonical"]');
        if (!canonicalLink) {
          canonicalLink = document.createElement('link');
          canonicalLink.setAttribute('rel', 'canonical');
          document.head.appendChild(canonicalLink);
        }
        canonicalLink.setAttribute('href', window.location.href);
        
        // Open Graph tags
        this.updateOpenGraphTags();
        
        // Twitter Card tags
        this.updateTwitterCardTags();
        
        // Structured Data
        this.addStructuredData();
      },
      
      updateOpenGraphTags() {
        const ogTags = {
          'og:title': this.seoTitle,
          'og:description': this.seoDescription,
          'og:image': window.location.origin + this.project.image,
          'og:url': window.location.href,
          'og:type': 'website',
          'og:site_name': 'Codetime - Desenvolvimento de Software'
        };
        
        Object.keys(ogTags).forEach(property => {
          let metaTag = document.querySelector(`meta[property="${property}"]`);
          if (!metaTag) {
            metaTag = document.createElement('meta');
            metaTag.setAttribute('property', property);
            document.head.appendChild(metaTag);
          }
          metaTag.setAttribute('content', ogTags[property]);
        });
      },
      
      updateTwitterCardTags() {
        const twitterTags = {
          'twitter:card': 'summary_large_image',
          'twitter:title': this.seoTitle,
          'twitter:description': this.seoDescription,
          'twitter:image': window.location.origin + this.project.image
        };
        
        Object.keys(twitterTags).forEach(name => {
          let metaTag = document.querySelector(`meta[name="${name}"]`);
          if (!metaTag) {
            metaTag = document.createElement('meta');
            metaTag.setAttribute('name', name);
            document.head.appendChild(metaTag);
          }
          metaTag.setAttribute('content', twitterTags[name]);
        });
      },
      
      addStructuredData() {
        // Remove scripts anteriores
        document.querySelectorAll('script[data-seo="portfolio"]').forEach(script => script.remove());
        
        // SoftwareApplication Schema
        const softwareSchema = {
          "@context": "https://schema.org",
          "@type": "SoftwareApplication",
          "name": this.project.title,
          "description": this.project.description,
          "url": window.location.href,
          "image": window.location.origin + this.project.image,
          "applicationCategory": this.project.category,
          "applicationSubCategory": this.marketNiche,
          "offers": {
            "@type": "Offer",
            "category": "Desenvolvimento de Software"
          },
          "creator": {
            "@type": "Organization",
            "name": "Codetime",
            "url": window.location.origin,
            "address": {
              "@type": "PostalAddress",
              "addressLocality": "Itajaí",
              "addressRegion": "SC",
              "addressCountry": "BR"
            }
          }
        };
        
        const script1 = document.createElement('script');
        script1.type = 'application/ld+json';
        script1.setAttribute('data-seo', 'portfolio');
        script1.text = JSON.stringify(softwareSchema);
        document.head.appendChild(script1);
        
        // Breadcrumb Schema
        const breadcrumbSchema = {
          "@context": "https://schema.org",
          "@type": "BreadcrumbList",
          "itemListElement": [
            {
              "@type": "ListItem",
              "position": 1,
              "name": "Início",
              "item": window.location.origin
            },
            {
              "@type": "ListItem",
              "position": 2,
              "name": "Portfolio",
              "item": window.location.origin + "/#portfolio"
            },
            {
              "@type": "ListItem",
              "position": 3,
              "name": this.project.title,
              "item": window.location.href
            }
          ]
        };
        
        const script2 = document.createElement('script');
        script2.type = 'application/ld+json';
        script2.setAttribute('data-seo', 'portfolio');
        script2.text = JSON.stringify(breadcrumbSchema);
        document.head.appendChild(script2);
      },
      
      openImageModal(image, title) {
        this.imageModal.image = image;
        this.imageModal.title = title;
        this.imageModal.show = true;
      },
      
      closeImageModal() {
        this.imageModal.show = false;
        this.imageModal.image = '';
        this.imageModal.title = '';
      }
    },
  };
</script>

<style scoped>
.bg_image--4 {
    background-image: url('/images/hero/analytics-hero.webp') !important;
    background-size: cover;
    background-position: center;
    background-repeat: no-repeat;
    background-color: #0b0b0b;
    position: relative;
  }
  .bg_image--4::before {
    content: "";
    position: absolute;
    inset: 0;
    background: rgba(0,0,0,0.85);
    pointer-events: none;
  }
  .bg_image--4 .rn-page-title { position: relative; z-index: 1; }

/* Ajustar o overlay existente para ficar mais escuro */
[data-black-overlay="5"]:before {
  opacity: 0.6;
}

/* Estilos para a logo quando acessado diretamente */
.default-header .logo img {
  max-height: 30px !important;
  height: auto !important;
  width: auto !important;
}

/* Garantir que o header tenha o mesmo estilo da página principal */
.default-header {
  background: rgba(0, 0, 0, 0.9) !important;
  backdrop-filter: blur(10px);
  z-index: 1000;
}

/* Forçar estilos da logo */
.logo img {
  max-height: 30px !important;
  height: auto !important;
  width: auto !important;
  object-fit: contain;
}

/* Estilos específicos para o header da página de detalhes */
.portfolio-details .default-header {
  position: fixed !important;
  top: 0 !important;
  left: 0 !important;
  right: 0 !important;
}

/* Garantir que a logo tenha o tamanho correto */
.portfolio-details .logo img {
  max-height: 30px !important;
  height: 30px !important;
  width: auto !important;
}

/* Forçar tema escuro no header */
.v-app-bar.default-header {
  background-color: rgba(0, 0, 0, 0.9) !important;
  color: white !important;
}

/* Garantir que os elementos do header sejam brancos */
.v-app-bar.default-header .v-btn,
.v-app-bar.default-header .v-toolbar__title,
.v-app-bar.default-header .v-toolbar__content {
  color: white !important;
}
</style>
<style lang="scss" scoped>
  .portfolio-details {
    .portfolio-view-list {
      .port-view {
        margin-right: 30px;
        margin-bottom: 20px;

        span {
          font-size: 14px;
          color: #6b6b6b;
          margin-bottom: 5px;
          display: block;
        }

        h4 {
          font-size: 18px;
          font-weight: 600;
          margin: 0;
        }
      }
    }
  }

  .tech-tags {
    display: flex;
    flex-wrap: wrap;
    gap: 10px;
    
    .tech-tag {
      background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
      color: white;
      padding: 8px 16px;
      border-radius: 20px;
      font-size: 12px;
      font-weight: 500;
      display: inline-block;
      transition: all 0.3s ease;
      
      &:hover {
        transform: translateY(-2px);
        box-shadow: 0 4px 12px rgba(102, 126, 234, 0.4);
      }
    }
  }

  /* Estilos para o botão do portfolio */
  .portfolio-details-btn {
    .btn-default {
      padding: 10px 20px;
      border-radius: 22px;
      font-size: 13px;
      font-weight: 500;
      transition: all 0.3s ease;
      
      &:hover {
        transform: translateY(-2px);
      }
    }
  }

  .list-style--1 {
    li {
      i {
        color: #667eea;
        margin-right: 10px;
      }
    }
  }

  /* Estilos para as miniaturas da galeria */
  .portfolio-gallery-thumbs {
    .portfolio-main-image {
      margin-bottom: 20px;
      
      .main-thumb {
        cursor: pointer;
        transition: all 0.3s ease;
        
        &:hover {
          transform: translateY(-2px);
          box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
        }
      }
    }
    
    .thumbs-grid {
      display: grid;
      grid-template-columns: repeat(auto-fit, minmax(120px, 1fr));
      gap: 12px;
      
      .thumb-item {
        cursor: pointer;
        border-radius: 8px;
        overflow: hidden;
        transition: all 0.3s ease;
        aspect-ratio: 16/9; /* Proporção de tela */
        
        &:hover {
          transform: translateY(-2px);
          box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
        }
        
        .thumb-image {
          width: 100%;
          height: 100%;
          object-fit: cover;
          border-radius: 8px;
        }
      }
    }
  }

  /* Estilos para o modal de imagem */
  .image-modal {
    .modal-image {
      max-width: 100%;
      // max-height: 80vh;
      object-fit: contain;
    }
  }

/* Estilos para projetos relacionados */
.related-work {
  transition: transform 0.3s ease, box-shadow 0.3s ease;
  border-radius: 12px;
  overflow: hidden;
  background: rgba(255, 255, 255, 0.05);
  backdrop-filter: blur(10px);
  border: 1px solid rgba(255, 255, 255, 0.1);
}

.related-work:hover {
  transform: translateY(-5px);
  box-shadow: 0 20px 40px rgba(0, 0, 0, 0.2);
}

.related-work .thumb {
  position: relative;
  overflow: hidden;
  border-radius: 8px;
}

.related-work .thumb img {
  width: 100%;
  height: 200px;
  object-fit: cover;
  transition: transform 0.3s ease;
}

.related-work:hover .thumb img {
  transform: scale(1.05);
}

.related-work .inner {
  padding: 20px 15px;
}

.related-work .inner h4 {
  margin-bottom: 8px;
  font-size: 18px;
  font-weight: 600;
}

.related-work .inner h4 a {
  color: #333;
  text-decoration: none;
  transition: color 0.3s ease;
}

.related-work .inner h4 a:hover {
  color: #007bff;
}

.related-work .inner .category {
  color: #666;
  font-size: 14px;
  font-weight: 500;
}

/* Responsividade para mobile */
@media (max-width: 600px) {
  .related-work .thumb img {
    height: 150px;
  }
  
  .related-work .inner {
    padding: 15px 10px;
  }
  
  .related-work .inner h4 {
    font-size: 16px;
  }
}
</style>
